/* prettier-ignore */

import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IDatasource } from 'ngx-ui-scroll';
import { DefaultImgService } from 'src/app/services';

@Component({
  selector: 'cicerone-list-events',
  templateUrl: './list-events.component.html',
  styleUrls: ['./list-events.component.scss'],  
})

export class ListEventsComponent {
  @Input() events?: any;
  @Input() eventsIconName?: string;

  private _defaultImgService = inject(DefaultImgService);
  
  datasource: IDatasource = {
    get: (index, count, success) => {
      const data = [];
      for (let i = index; i <= index + count - 1; i++) {
        if (this.events?.length > i)
          data.push({type: 'item', data: this.events[i]});
        // else if (this.events?.length === i)
        //   data.push({type: 'more', data: []})
      }
      success(data);
    },
    settings: {
      horizontal: true,
      minIndex: 0,
      startIndex: 0
    }
  };

  constructor(
    public translate: TranslateService, 
    private router: Router
  ) {}
  
  goToSubCategoriesList(itemID) {
    this.router.navigate([`/${itemID}`]);
  }

  /**
   * @desciption Gets the default image file name for the card
   * @param index
   * @returns 
   */
  public getDefaultImgFileName(index: number): string {
    return this._defaultImgService.getEventDefaultImgFileName(
      index,
    );
  }
}
